import { Injectable, OnDestroy } from '@angular/core';
import { environment } from '@environment';
import { ReplaySubject } from 'rxjs';
import Tracker from '@openreplay/tracker';

@Injectable({
  providedIn: 'root',
})
export class OpenReplayService implements OnDestroy {
  private destroy$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  private readonly OPEN_REPLAY_ENABLED = environment.OPEN_REPLAY_ENABLED;
  private readonly OPEN_REPLAY_PROJECT_KEY = environment.OPEN_REPLAY_PROJECT_KEY;

  private tracker: Tracker | null = null;

  private VOID_METHOD = () => {};

  constructor() {}

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  public async init(): Promise<void> {
    if (!this.OPEN_REPLAY_ENABLED) {
      this.zeroMethods();

      // eslint-disable-next-line no-console
      console.log(`Open Replay Disabled - won't init.`);
      return;
    }

    try {
      this.tracker = new Tracker({
        projectKey: this.OPEN_REPLAY_PROJECT_KEY,
      });

      const startResult = await this.tracker.start();

      if (startResult.success) {
        // eslint-disable-next-line no-console
        console.log(`Open Replay succesfully started. SessionID: "${this.tracker.getSessionID()}"`);
      } else {
        console.warn(`Failed to start Open Replay`);
        this.zeroMethods();
      }
    } catch (err) {
      this.zeroMethods();
      console.warn('Error Initializing OpenReplay Tracker.');
      console.error(err);
    }
  }

  public zeroMethods(): void {
    this.setUserID = this.VOID_METHOD;
    this.setMeta = this.VOID_METHOD;
    this.resetSession = this.VOID_METHOD;
  }

  public setUserID(userId: string): void {
    this.tracker.setUserID(userId);
  }

  public setMeta(metaKey: string, metaValue: string): void {
    this.tracker.setMetadata(metaKey, metaValue);
  }

  public resetSession(): void {
    // Stop the current session
    this.tracker.stop();

    // Start a new session
    this.tracker.start();
  }
}
